import { useState } from "react";
import { useDispatch } from "react-redux";

import Warning from "../../../../../Components/common/Warning/Warning";
import ToggleButton from "../../../../../Components/common/ToggleButton/ToggleButton";

import { RequestDeleteAgentPolicy } from "../../../../../store/actions/integrationsActions";

const Header = ({
  policy,
  showPolicyInfo = false,
  selectedHost,
  toggleProps = { show: false, text: "", active: false, onClick: () => {} },
}) => {
  const dispatch = useDispatch();

  const [showWarning, setShowWarning] = useState(false);

  const warningClickOKHandler = () => {
    dispatch(RequestDeleteAgentPolicy({ id: policy.id, host: selectedHost }));
    setShowWarning(false);
  };

  return (
    <>
      <div className="agent-policies-header">
        <h3 className="agent-policies-header__title">
          Threat Hunter / <span>{selectedHost}</span>
        </h3>
        {toggleProps.show ? (
          <div className="agent-policies-header__status">
            <span>{toggleProps.text}</span>
            <ToggleButton active={toggleProps.active} onClick={toggleProps.onClick} />
          </div>
        ) : null}
        {showPolicyInfo ? (
          <>
            <p className="agent-policies-header__name">
              <span>Policy Name:</span> {policy.name || "-"}
            </p>
            <p className="agent-policies-header__description">
              <span>Policy Desc:</span> {policy.description || "-"}
            </p>
            <button
              className="agent-policies-header__delete-button danger-button"
              onClick={() => setShowWarning(true)}>
              Delete Policy
            </button>
          </>
        ) : null}
      </div>

      <Warning
        onClickOk={warningClickOKHandler}
        show={showWarning}
        setShow={setShowWarning}
        text="Are you sure you want to delete this policy ?"
        article="Confirm delete"
        cancelDisable={false}
      />
    </>
  );
};

export default Header;
